import React, { Component } from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import { Dropdown } from "react-bootstrap";
import SearchFoodNutrition from "../foodDatabase/searchFoodNutrition";
import PaginatedTable from "../../../sharedComponents/tableWithPagination";
import KeywordSearch from "../../../sharedComponents/keywordSearch";
import NoRecipeImage from "../../../assets/images/no-recipes-found.png";
import { searchFoodNutrition, resetField } from "../../../store/actions";
import Loader from "../../../sharedComponents/preloader";
import { objToQueryString } from "../../../utils/common";

import "./FoodDatabase.scss";
import {
	togglePreloader,
	getFoodDatabase,
	getFoodListCardView,
	getFoodDatabaseLevelTwo,
	getFoodDatabaseLevelThree,
	getFoodDatabaseLevelFour,
} from "../../../store/actions";
import RenderTree from "./renderTree";
import FoodItemCardView from "../../../sharedComponents/foodItemCardView";

const initialState = {
	foodDatabaseLevel1: [],
	foodListCardViewData: [],
	foodListCardSearchData: [],
	selectedFoodDatabaseLevel1: null,
	selectedFoodDatabaseLevel2: null,
	selectedFoodDatabaseLevel3: null,
	selectedFoodDatabaseLevel4: null,
};

class FoodDatabase extends Component {
	state = {
		...initialState,
		search: "",
		isLoading: false,
		searchLoading: true,
		show: false,
		filterQuery: {
			ordering: "id",
			limit: 30,
			search: "",
			declined: "True"
		},

		offset: 30,
	};

	componentDidMount() {
		// this.props.getFoodDatabase();
		this.props.getFoodListCardView(objToQueryString(this.state.filterQuery));
	}

	componentDidUpdate(prevProps, prevState) {
		const {
			foodDatabaseLevel1: foodDatabase,
			selectedFoodDatabaseLevel1,
			selectedFoodDatabaseLevel2,
			selectedFoodDatabaseLevel3,
			foodListCardViewData,
			foodListCardSearchData,
			filterQuery,
			offset,
			search
		} = this.state;
		const { foodDatabaseLevel1, foodNutritionList, atBottom, foodDatabaseCardResult, foodDatabaseLevel2, foodDatabaseLevel3, foodDatabaseLevel3_food, foodDatabaseLevel4 } =
			this.props;
		if (prevProps.foodDatabaseCardResult !== foodDatabaseCardResult) {
			let list = foodListCardViewData.concat(foodDatabaseCardResult.results);
			this.setState({
				isLoading: false,
				searchLoading: false,
				foodListCardViewData: list
			})
		}

		if (prevProps.foodNutritionList !== foodNutritionList) {
			let searchList = foodNutritionList.results !== undefined ? foodNutritionList.results : [];
			this.setState({
				isLoading: false,
				foodListCardSearchData: searchList
			})
		}

		if (prevProps.atBottom !== atBottom) {
			if (atBottom) {
				this.props.getFoodListCardView(`${objToQueryString(filterQuery)}&offset=${offset}`);
				let offsetValue = offset + 30;
				this.setState({ isLoading: true, offset: offsetValue })
			}
		}

		if (prevProps.foodDatabaseLevel1 !== foodDatabaseLevel1) {
			this.setState({ foodDatabaseLevel1: this.processList(foodDatabaseLevel1) });
			const { foodDatabaseBackData } = this.props;

			if (foodDatabaseBackData) {
				return (foodDatabaseBackData.hier1 || foodDatabaseBackData.hier1_data) &&
					(foodDatabaseBackData.hier2 || foodDatabaseBackData.hier2_data) &&
					(foodDatabaseBackData.hier3 || foodDatabaseBackData.hier3_data)
					? this.handleNavigation(
						{
							id:
								foodDatabaseBackData.hier1 ||
								(foodDatabaseBackData.hier1_data && foodDatabaseBackData.hier1_data.id),
						},
						{
							id:
								foodDatabaseBackData.hier2 ||
								(foodDatabaseBackData.hier2_data && foodDatabaseBackData.hier2_data.id),
						},
						{
							id:
								foodDatabaseBackData.hier3 ||
								(foodDatabaseBackData.hier3_data && foodDatabaseBackData.hier3_data.id),
						}
					)
					: (foodDatabaseBackData.hier1 || foodDatabaseBackData.hier1_data) &&
						(foodDatabaseBackData.hier2 || foodDatabaseBackData.hier2_data)
						? this.handleNavigation(
							{
								id:
									foodDatabaseBackData.hier1 ||
									(foodDatabaseBackData.hier1_data && foodDatabaseBackData.hier1_data.id),
							},
							{
								id:
									foodDatabaseBackData.hier2 ||
									(foodDatabaseBackData.hier2_data && foodDatabaseBackData.hier2_data.id),
							}
						)
						: foodDatabaseBackData.hier1 || foodDatabaseBackData.hier1_data
							? this.handleNavigation({
								id:
									foodDatabaseBackData.hier1 ||
									(foodDatabaseBackData.hier1_data && foodDatabaseBackData.hier1_data.id),
							})
							: null;
			}
		}

		if (prevProps.foodDatabaseLevel2 !== foodDatabaseLevel2) {
			foodDatabase.map((item) => {
				if (selectedFoodDatabaseLevel1 && item.id === selectedFoodDatabaseLevel1.id) {
					item.sub_category = this.processList(foodDatabaseLevel2);
				}
				return null;
			});
			foodDatabase && foodDatabase.length && this.setState({ foodDatabaseLevel1: foodDatabase });
		}

		if (
			prevProps.foodDatabaseLevel3 !== foodDatabaseLevel3 ||
			prevProps.foodDatabaseLevel3_food !== foodDatabaseLevel3_food
		) {
			foodDatabase.map((item) => {
				if (selectedFoodDatabaseLevel1 && item.id === selectedFoodDatabaseLevel1.id) {
					item.sub_category.map((itemLevel2) => {
						if (selectedFoodDatabaseLevel2 && itemLevel2.id === selectedFoodDatabaseLevel2.id) {
							itemLevel2.sub_category = this.processList(foodDatabaseLevel3);
							itemLevel2.food_category = this.processList(foodDatabaseLevel3_food, false);
						}
						return null;
					});
				}
				return null;
			});
			foodDatabase && foodDatabase.length && this.setState({ foodDatabaseLevel1: foodDatabase });
		}

		if (prevProps.foodDatabaseLevel4 !== foodDatabaseLevel4) {
			foodDatabase.map((item) => {
				if (selectedFoodDatabaseLevel1 && item.id === selectedFoodDatabaseLevel1.id) {
					item.sub_category.map((itemLevel2) => {
						if (selectedFoodDatabaseLevel2 && itemLevel2.id === selectedFoodDatabaseLevel2.id) {
							itemLevel2.sub_category.map((itemLevel3) => {
								if (selectedFoodDatabaseLevel3 && itemLevel3.id === selectedFoodDatabaseLevel3.id) {
									itemLevel3.sub_category = this.processList(foodDatabaseLevel4, false);
								}
								return null;
							});
						}
						return null;
					});
				}
				return null;
			});
			foodDatabase && foodDatabase.length && this.setState({ foodDatabaseLevel1: foodDatabase });
		}
	}

	componentWillUnmount() {
		this.props.resetField("FoodDatabase.foodNutritionList", []);
		this.props.resetField("FoodDatabase.foodDatabaseBackData", null);
	}

	processList = (list, hasLink = true) => {
		return list.map((item) => {
			return { ...item, sub_category: [], food_category: [], hasLink };
		});
	};

	getLevelFour = (item) => {
		this.setState(
			{
				selectedFoodDatabaseLevel3: item,
			},
			() => this.props.getFoodDatabaseLevelFour(`hier3_id=${item.id}`)
		);
	};

	getLevelThree = (item) => {
		this.setState(
			{
				selectedFoodDatabaseLevel2: item,
			},
			() => this.props.getFoodDatabaseLevelThree(`p=${item.id}`)
		);
	};

	getLevelTwo = (item) => {
		this.setState(
			{
				selectedFoodDatabaseLevel1: item,
			},
			() => this.props.getFoodDatabaseLevelTwo(`p_id=${item.id}`)
		);
	};

	getInnerLevel = (event, level) => {
		switch (level) {
			case 2:
				return this.getLevelTwo(event);
			case 3:
				return this.getLevelThree(event);
			case 4:
				return this.getLevelFour(event);
			default:
				return null;
		}
	};

	goToPage = (event, level) => {
		this.props.resetField("FoodDatabase.foodDatabaselevels", event);
		this.props.history.push(`/nutrition/food-database/${event.id}/details`);
	};

	renderTree = () => {
		const { foodDatabaseLevel1 } = this.state;
		return foodDatabaseLevel1 && foodDatabaseLevel1.length ? (
			<RenderTree
				categoryGroupList={foodDatabaseLevel1}
				onSelect={(event, level) => this.getInnerLevel(event, level)}
				onClick={(event, level) => this.goToPage(event, level)}
			/>
		) : null;
	};

	renderCard = (data) => {
		return data && data.length ? (
			<FoodItemCardView
				history={this.props.history}
				foodListCardViewData={data}
				isAdmin={this.props.isAdmin}
			/>
		) : null;
	};

	scrollToView = () => {
		const nodes = [...document.querySelectorAll(".tree-item-link.active")];
		nodes &&
			nodes.length &&
			nodes[nodes.length - 1].scrollIntoView({
				behavior: "smooth",
				block: "start",
				inline: "nearest",
			});
	};

	handleNavigation = (levelOneData, levelTwoData, levelThreeData) => {
		levelOneData &&
			this.setState({ selectedFoodDatabaseLevel1: levelOneData }, () => {
				Promise.resolve(this.props.getFoodDatabaseLevelTwo(`p_id=${levelOneData.id}`)).then(() => {
					this.scrollToView();
					levelTwoData &&
						this.setState({ selectedFoodDatabaseLevel2: levelTwoData }, () => {
							Promise.resolve(this.props.getFoodDatabaseLevelThree(`p=${levelTwoData.id}`)).then(() => {
								this.scrollToView();
								levelThreeData &&
									this.setState({ selectedFoodDatabaseLevel3: levelThreeData }, () => {
										Promise.resolve(
											this.props.getFoodDatabaseLevelFour(`hier3_id=${levelThreeData.id}`)
										).then(() => {
											this.scrollToView();
										});
									});
							});
						});
				});
			});
	};

	dropdownClick = (path) => {
		this.props.history.push(path);
	};

	columns = [
		{
			Header: "Food",
			accessor: "long_desc",
			sortable: false,
			width: 400,
			Cell: ({ original }) => (
				<span href="#" className="text-primary-dark pointer" onClick={() => this.goToPage(original)}>
					{original.long_desc ? original.long_desc : ""}
				</span>
			),
		},
		{
			Header: "Hierarchy",
			sortable: false,
			width: 400,
			Cell: ({ original }) => (
				<div>
					<label>
						{original.hier1_data && original.hier1_data.name ? (
							<span
								href="#"
								className="text-primary-dark pointer"
								onClick={() => this.handleNavigation(original.hier1_data)}>
								{original.hier1_data.name} &bull;
							</span>
						) : (
							""
						)}
						{original.hier2_data && original.hier2_data.name ? (
							<span
								href="#"
								className="text-primary-dark pointer"
								onClick={() => this.handleNavigation(original.hier1_data, original.hier2_data)}>
								{original.hier2_data.name} &bull;
							</span>
						) : (
							""
						)}
						{original.hier3_data && original.hier3_data.name ? (
							<span
								href="#"
								className="text-primary-dark pointer"
								onClick={() =>
									this.handleNavigation(original.hier1_data, original.hier2_data, original.hier3_data)
								}>
								{original.hier3_data.name}
							</span>
						) : (
							""
						)}
					</label>
				</div>
			),
		},
		{
			Header: "Useful",
			accessor: "useful",
			sortable: false,
			width: 100,
			Cell: ({ original }) => (original.useful ? <i className="icon icon-check text-primary" /> : ""),
		},
	];

	setLoaderTrue = (data) => {
		this.setState({
			searchLoading: data
		})
	}

	setSearch = (search) => {
		this.setState({ search, foodListCardSearchData: [] })
	}

	foodListHeader = () => {
		return (
			<div className="table-header pt-0">
				<h3 className="flex-fill m-0">Food Database</h3>
				{this.props.isAdmin ? (
					<Dropdown drop="down" show={this.state.show} className="approve-btn mr-2">
						<Dropdown.Toggle
							onClick={() => this.setState({ show: true })}
							className="btn btn-primary-dark btn-ghost mr-2">
							Patient Submissions
						</Dropdown.Toggle>
						<Dropdown.Menu>
							<ul className="menu-list">
								<li onClick={() => this.dropdownClick("/nutrition/food-database/approval")}>
									Food Approval
								</li>
							</ul>
						</Dropdown.Menu>
					</Dropdown>
				) : null}
				<SearchFoodNutrition
					setLoaderTrue={this.setLoaderTrue}
					setSearch={this.setSearch}
					getFoodListCardView={this.props.getFoodListCardView}
				/>
			</div>
		)
	}

	render() {
		const { isLoading, searchLoading } = this.state;
		return (
			<section className="page page-food-database">
				<div className="container">
					<div className="table-container">
						{this.foodListHeader()}
					</div>
					<div className="row card-wrap">
						{searchLoading ? (
							<Loader show={searchLoading} />
						) : null}
						<div className="col">
							<div className="">
								{
									this.state.search === ""
										? (
											this.renderCard(this.state.foodListCardViewData)
										)
										: (this.state.foodListCardSearchData.length !== 0)
											? (
												<div>
													<h4 className="text-primary-dark">
														Your search found {this.props.foodNutritionList.count} result(s){" "}
													</h4>
													{this.renderCard(this.state.foodListCardSearchData)}
												</div>
											)
											: (!this.state.searchLoading)
												? (
													<div className="alert alert-info text-center w-100 m-3 no-recipes-found">
														<img src={NoRecipeImage} alt="No recipes found" />
														<div>No items found!</div>
													</div>
												)
												:
												null
								}
							</div>
						</div>
						{isLoading ? (
							<Loader show={isLoading} />
						) : null}
					</div>
				</div>
			</section>
		);
	}
}


const mapStateToProps = (state) => {
	const { FoodDatabase, UI, Auth } = state;
	return {
		isAdmin: get(Auth, "isAdmin", "P"),
		foodDatabaseLevel1: get(FoodDatabase, "foodDatabaseResult", []),
		foodDatabaseLevel2: get(FoodDatabase, "foodDatabaseLevel2Result.results", []),
		foodDatabaseCardResult: get(FoodDatabase, "foodDatabaseCardResult", []),
		foodDatabaseLevel3_food: get(FoodDatabase, "foodDatabaseLevel3Result.food", []),
		foodDatabaseLevel3: get(FoodDatabase, "foodDatabaseLevel3Result.sub_category", []),
		foodDatabaseLevel4: get(FoodDatabase, "foodDatabaseLevel4Result.results", []),
		foodNutritionList: get(state, "FoodDatabase.foodNutritionList", []),
		foodDatabaseBackData: get(state, "FoodDatabase.foodDatabaseBackData", null),
		recipeFoodGroups: get(state, "AddRecipe.recipeFoodGroups.results", []),
		atBottom: UI.atBottom,
	};
};

const mapDispatchToProps = {
	togglePreloader,
	getFoodDatabase,
	getFoodListCardView,
	getFoodDatabaseLevelTwo,
	getFoodDatabaseLevelThree,
	getFoodDatabaseLevelFour,
	searchFoodNutrition,
	resetField,
};

export default connect(mapStateToProps, mapDispatchToProps)(FoodDatabase);
